import React from "react";
import ReactDOM from "react-dom/client";
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "remixicon/fonts/remixicon.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./sass/styles.scss";
import AppRoutes from "./settings/routes/index.Routes";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppRoutes />);
